import { useDispatch, useSelector } from 'react-redux'
import { updateModalStatus } from 'redux/modals/actions'
import { RootState } from 'redux/store'

import CustomCardArt from '@card-actions/custom-card-art'
import config from 'const/config'
import { customCardArtModalContainerId } from 'const/modalContainerId'
import triggerAnalyticsEvent from 'helpers/triggerAnalyticsEvent'
import { MFEConfig } from 'syf-js-utilities/typings/mfeConfig'
import {
  AuthenticationRedirectProps,
  handleMFEAuthenticationRedirect
} from 'helpers/authenticationRedirect'
import routes from 'const/routes'
import getMFEConfig from 'helpers/getMFEConfig'

const CustomCardArtModal = () => {
  const dispatch = useDispatch()
  const { selectedAccount, modalId } = useSelector((state: RootState) => ({
    selectedAccount:
      state.modals.selectedAccount ||
      sessionStorage.getItem('selectedAccountId'),
    modalId: state.modals.modalId
  }))

  const mfeConfig: MFEConfig = getMFEConfig('customCardArt')

  const handleCloseModal = () => {
    dispatch(updateModalStatus('', '', true))
  }

  const handleAuthenticationRedirect = () => {
    const props: AuthenticationRedirectProps = {
      navigateTo: routes.HOME,
      modal: 'CustomCardArt',
      scope: 'read write write:sensitive'
    }

    handleMFEAuthenticationRedirect(props)
  }

  return (
    <CustomCardArt
      authenticationRedirect={handleAuthenticationRedirect}
      closeModal={handleCloseModal}
      containerId={customCardArtModalContainerId(selectedAccount)}
      envProp={config.APP_ENV === 'production' ? 'production' : 'development'}
      isModalOpen={modalId === 'CustomCardArt'}
      mfeConfig={mfeConfig}
      selectedAccountId={selectedAccount}
      triggerAnalyticsEvent={triggerAnalyticsEvent}
    />
  )
}

export default CustomCardArtModal
